export const getColors = {
  mainBlue: "#2eafd3",
};
